module.exports = __webpack_public_path__ + "img/icon_map_10_on_001.82d2ef7b.png";